module.exports = __webpack_public_path__ + "static/media/SL.f36ce21e.png";